import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app/App";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";

// React Query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// MSAL
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, persistMicrosoftTenantId } from "./app/auth/msalConfig";

// App auth context
import { AuthProvider } from "./providers/AuthProvider";

const queryClient = new QueryClient();
const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
  // Initialize MSAL
  await msalInstance.initialize();

  // Process Microsoft redirect response
  const response = await msalInstance.handleRedirectPromise();

  if (response?.account) {
    persistMicrosoftTenantId(response);
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      persistMicrosoftTenantId(accounts[0]);
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ThemeProvider>
          </AuthProvider>
        </MsalProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

startApp();
